import Vue from "vue";
import Router from "vue-router";
import Resource from "vue-resource";
import MainPage from "@/components/MainPage";
import { resolve } from "path";

Vue.use(Router);
Vue.use(Resource);

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // 前进后腿返回原始位置，history模式可用
    } else {
      return { x: 0, y: 0 }; // 路由跳转返回顶部，history模式可用
    }
  },
  routes: [
    {
      path: "/",
      name: "MainPage",
      component: MainPage,
    },
    {
      path: "*",
      name: "NotFound404",
      component: (resolve) =>
        require(["../components/NotFound404.vue"], resolve),
    },
    {
      path: "/video",
      name: "video",
      component: (resolve) => require(["../components/video.vue"], resolve),
    },
    {
      path: "/services",
      name: "ServicesPage",
      component: (resolve) =>
        require(["../components/services/ServicesPage.vue"], resolve),
    },
    {
      path: "/product/delivery",
      name: "DeliveryPage",
      component: (resolve) =>
        require(["../components/services/DeliveryPage.vue"], resolve),
    },
    {
      path: "/product/connection",
      name: "ConnectionPage",
      component: (resolve) =>
        require(["../components/services/ConnectionPage.vue"], resolve),
    },
    {
      path: "/services/sdwan",
      name: "SdwanPage",
      component: (resolve) =>
        require(["../components/services/SdwanPage.vue"], resolve),
    },
    {
      path: "/product/global",
      name: "GlobalAppPage",
      component: (resolve) =>
        require(["../components/services/GlobalAppPage.vue"], resolve),
    },
    {
      path: "/product/mobility",
      name: "MoblieClient",
      component: (resolve) =>
        require(["../components/MobileClient/mobileClient.vue"], resolve),
    },

    {
      path: "/solutions",
      name: "SolutionsPage",
      component: (resolve) =>
        require(["../components/solutions/SolutionsPage.vue"], resolve),
    },
    {
      path: "/solutions/enterprise",
      name: "Enterprise",
      component: (resolve) =>
        require(["../components/Enterprise/enterprise.vue"], resolve),
    },
    {
      path: "/solutions/virtualNetwork",
      name: "VirtualNetwork",
      component: (resolve) =>
        require(["../components/VirtualNetwork/virtualNetwork.vue"], resolve),
    },
    {
      path: "/solutions/saas",
      name: "SaaSPage",
      component: (resolve) =>
        require(["../components/solutions/SaaSPage.vue"], resolve),
    },
    {
      path: "/solutions/cloud",
      name: "CloudPrivatePage",
      component: (resolve) =>
        require(["../components/solutions/CloudPrivatePage.vue"], resolve),
    },
    {
      path: "/solutions/mpls",
      name: "MplsPage",
      component: (resolve) =>
        require(["../components/solutions/MplsPage.vue"], resolve),
    },
    {
      path: "/solutions/global",
      name: "GlobalSolutionPage",
      component: (resolve) =>
        require(["../components/solutions/GlobalSolutionPage.vue"], resolve),
    },
    {
      path: "/about",
      name: "AboutUs",
      component: (resolve) => require(["../components/AboutUs.vue"], resolve),
    },
    {
      path: "/news",
      name: "News",
      component: (resolve) => require(["../components/New/new.vue"], resolve),
    },
    {
      path: "/leader-ship",
      name: "Leadership",
      component: (resolve) =>
        require(["../components/Leadership.vue"], resolve),
    },
    {
      path: "/investor",
      name: "Investor",
      component: (resolve) => require(["../components/investor.vue"], resolve),
    },
    {
      path: "/free-trial",
      name: "FreeTrial",
      component: (resolve) => require(["../components/Free.vue"], resolve),
    },
    {
      path: "/partner-apply",
      name: "PartnerApply",
      component: (resolve) => require(["../components/Partner.vue"], resolve),
    },
    {
      path: "/free-application",
      name: "FreeApplication",
      component: (resolve) =>
        require(["../components/FreeApplication.vue"], resolve),
    },
    {
      path: "/yunqi",
      name: "YunQiCoupon",
      component: (resolve) =>
        require(["../components/coupon/YunQi.vue"], resolve),
    },
    {
      path: "/yunqi/coupon",
      name: "CouponApply",
      component: (resolve) =>
        require(["../components/coupon/Apply.vue"], resolve),
    },
    {
      path: "/join",
      name: "JoinUs",
      component: (resolve) => require(["../components/join.vue"], resolve),
    },
    {
      path: "/expert",
      name: "expert",
      component: (resolve) => require(["../components/expert.vue"], resolve),
    },
    {
      path: "/award",
      name: "awards",
      component: (resolve) =>
        require(["../components/Award/award.vue"], resolve),
    },
    {
      path: "/services/download",
      name: "download",
      component: (resolve) =>
        require(["../components/services/Download.vue"], resolve),
    },
    { path: "/Download", redirect: "/services/download" },
    {
      path: "/services/download/m100",
      name: "downloadM100",
      component: (resolve) =>
        require(["../components/services/DownloadM100.vue"], resolve),
    },

    { path: "/Download-M100", redirect: "/services/download/m100" },
    {
      path: "/services/download/sase",
      name: "downloadSASE",
      component: (resolve) =>
        require(["../components/services/DownloadSASE.vue"], resolve),
    },

    { path: "/Download-YAT", redirect: "/services/download/yat" },
    {
      path: "/services/download/yat",
      name: "downloadYAT",
      component: (resolve) =>
        require(["../components/services/DownloadYAT.vue"], resolve),
    },

    { path: "/Download-Sase", redirect: "/services/download/sase" },
    {
      path: "/services/download/netool",
      name: "downloadNetool",
      component: (resolve) =>
        require(["../components/services/DownloadNetool.vue"], resolve),
    },
    { path: "/Download-Tool", redirect: "/services/download/netool" },
    {
      path: "/services/download/m100",
      name: "downloadM100",
      component: (resolve) =>
        require(["../components/services/DownloadM100.vue"], resolve),
    },
    {
      path: "/services/download/sase",
      name: "downloadSASE",
      component: (resolve) =>
        require(["../components/services/DownloadSASE.vue"], resolve),
    },
    {
      path: "/services/download/netool",
      name: "downloadNetool",
      component: (resolve) =>
        require(["../components/services/DownloadNetool.vue"], resolve),
    },

    {
      path: "/android",
      name: "android",
      component: (resolve) => require(["../components/Android.vue"], resolve),
    },
    {
      path: "/technology/download",
      name: "Download",
      component: (resolve) =>
        require(["../components/DataDownload/dataDownload.vue"], resolve),
    },
    //新闻详情

    {
      path: "/NewDetail/1",
      component: (resolve) => require(["../components/New/N1.vue"], resolve),
    },
    {
      path: "/NewDetail/2",
      component: (resolve) => require(["../components/New/N2.vue"], resolve),
    },

    // 设备详情
    {
      path: "/services/device/R100-X6",
      name: "device",
      component: (resolve) =>
        require(["../components/devices/DeviceMain.vue"], resolve),
      children: [
        {
          path: "/",
          component: (resolve) =>
            require(["../components/devices/R100X6.vue"], resolve),
        },
        {
          path: "/services/device/R200-X6",
          component: (resolve) =>
            require(["../components/devices/R200X6.vue"], resolve),
        },
        {
          path: "/services/device/R500-X8S",
          component: (resolve) =>
            require(["../components/devices/R500X8S.vue"], resolve),
        },
        {
          path: "/services/device/A55",
          component: (resolve) =>
            require(["../components/devices/A55.vue"], resolve),
        },
        {
          path: "/services/device/D100-AWL5",
          component: (resolve) =>
            require(["../components/devices/D100AWL5.vue"], resolve),
        },
        {
          path: "/services/device/D200-X4",
          component: (resolve) =>
            require(["../components/devices/D200X4.vue"], resolve),
        },
        {
          path: "/services/device/V100",
          component: (resolve) =>
            require(["../components/devices/V100.vue"], resolve),
        },
        // 下面是不用的
        {
          path: "/services/device/R200",
          component: (resolve) =>
            require(["../components/devices/R200.vue"], resolve),
        },
        {
          path: "/services/device/D100",
          component: (resolve) =>
            require(["../components/devices/D100.vue"], resolve),
        },
        {
          path: "/services/device/S200",
          component: (resolve) =>
            require(["../components/devices/S200.vue"], resolve),
        },
        {
          path: "/services/device/S50",
          component: (resolve) =>
            require(["../components/devices/S50.vue"], resolve),
        },

        {
          path: "/services/device/comparison",
          component: (resolve) =>
            require(["../components/devices/comparison.vue"], resolve),
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js